module.exports = __webpack_public_path__ + "img/vacation.f38ab411.png";